module.exports = __webpack_public_path__ + "static/media/file-jpg.57cb3ef2.svg";